<!--  -->
<template>
  <div>
    <Header :isactive="1" />
    <div id="banner" class="bannerSlide">
      <div class="swiper-container swiper-no-swiping">
        <div class="swiper-wrapper">
          <div class="swiper-slide">
            <img src="@/assets/image/banner-1.jpg" alt="" />
            <div class="text-content">
              <p :class="animate1(1, 'title')">客户第一</p>
              <p :class="animate1(2, 'desc')">始终以为客户创造价值为先</p>
            </div>
          </div>
          <div class="swiper-slide">
            <img src="@/assets/image/banner-2.jpg" alt="" />
            <div class="text-content">
              <p :class="animate1(3, 'title')">拥抱变化</p>
              <p :class="animate1(4, 'desc')">
                打破成规，不断拥抱变化寻求突破，持续成长
              </p>
            </div>
          </div>
          <div class="swiper-slide">
            <img src="@/assets/image/banner-3.jpg" alt="" />
            <div class="text-content">
              <p :class="animate1(5, 'title')">尊重人才</p>
              <p :class="animate1(6, 'desc')">我们认为员工是公司最宝贵的财富</p>
            </div>
          </div>
        </div>
        <div class="swiper-pagination"></div>
        <div class="pagination-list">
          <div
            :class="currentPage == 0 ? 'item active' : 'item'"
            @mouseover="handleStop(0)"
          ></div>
          <div
            :class="currentPage == 1 ? 'item active' : 'item'"
            @mouseover="handleStop(1)"
          ></div>
          <div
            :class="currentPage == 2 ? 'item active' : 'item'"
            @mouseover="handleStop(2)"
          ></div>
        </div>
      </div>
    </div>
    <div id="content">
      <div id="company-desc">
        <div class="company-content">
          <div class="text-tontent">
            <p class="trans">YOUWO TECH</p>
            <p class="title">优我科华</p>
            <p class="desc desc1">我们的愿景：做好用的"机器视觉产品"</p>
          </div>
          <ul class="show-list overflow">
            <li class="item first left overflow">
              <img class="bg-img" src="@/assets/image/company-1.jpg" alt="" />
              <div class="modle" @click="handleLink('about', 0)">
                <p class="title">了解我们</p>
                <img class="go-to" src="@/assets/image/go-to.png" alt="" />
              </div>
            </li>
            <li class="item left overflow">
              <img class="bg-img" src="@/assets/image/company-2.jpg" alt="" />
              <div class="modle" @click="handleLink('about', 4040)">
                <p class="title">企业文化</p>
                <img class="go-to" src="@/assets/image/go-to.png" alt="" />
              </div>
            </li>
            <li class="item left overflow">
              <img class="bg-img" src="@/assets/image/company-3.jpg" alt="" />
              <div class="modle" @click="handleLink('develop', 490)">
                <p class="title">职业发展</p>
                <img class="go-to" src="@/assets/image/go-to.png" alt="" />
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div id="company-server">
        <div class="server-content overflow">
          <div class="title-list left">
            <div
              :class="isShow == 0 ? 'title-item current' : 'title-item'"
              @mouseover="overShow(0)"
            >
              <p class="trans">MARKETING SERVICE</p>
              <p class="title">产品服务</p>
              <div class="title-after left"></div>
            </div>
            <div
              :class="isShow == 2 ? 'title-item current' : 'title-item'"
              @mouseover="overShow(2)"
            >
              <p class="trans">DATA SERVICE SERVICE</p>
              <p class="title">数据服务</p>
              <div class="title-after left"></div>
            </div>
          </div>
          <div class="content-list right overflow">
            <ul v-show="isShow == 0" class="content-item overflow">
              <li class="item first left overflow">
                <img class="bg-img" src="@/assets/image/making-1.png" alt="" />
                <!-- <div class="modle" @click="handleLink('product', 2)"> -->
                <div class="modle" @click="handleLink('LCDPanel', 2)">
                  <p class="title">液晶面板制造</p>
                  <img class="go-to" src="@/assets/image/go-to.png" alt="" />
                </div>
              </li>
              <li class="item left overflow">
                <img class="bg-img" src="@/assets/image/making-2.png" alt="" />
                <div class="modle" @click="handleLink('CardManufacturing', 1)">
                  <p class="title">汽车制造业</p>
                  <img class="go-to" src="@/assets/image/go-to.png" alt="" />
                </div>
              </li>
              <li class="item left overflow finding">
                <img class="bg-img" src="@/assets/image/making-3.jpg" alt="" />
                <div class="modle">
                  <p class="title">其他</p>
                  <img class="go-to" src="@/assets/image/go-to.png" alt="" />
                </div>
              </li>
            </ul>
            <div v-show="isShow == 1" class="content-item finding">
              <img class="bg-img" src="@/assets/image/finding-1.png" alt="" />
              <div class="modle">
                <p class="title">正在探索中…</p>
                <p class="trans">尽请期待</p>
              </div>
            </div>
            <div v-show="isShow == 2" class="content-item finding">
              <img class="bg-img" src="@/assets/image/finding-2.png" alt="" />
              <div class="modle">
                <p class="title">正在探索中…</p>
                <p class="trans">尽请期待</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer />
    <Top />
  </div>
</template>

<script>
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Top from "@/components/Top";
import Swiper from "swiper";
import "@/assets/css/swiper.css";

var auto = null;
export default {
  components: { Header: Header, Footer: Footer, Top: Top },
  computed: {
    animate1() {
      return function(_idx, _class) {
        let _className = "none";
        if (this["ad" + _idx] == true) {
          _className = "animated fadeInUp " + _class;
        } else if (this["ad" + _idx] == false) {
          _className = "animated fadeOutDown " + _class;
        }
        return _className;
      };
    }
  },
  data() {
    return {
      isShow: 0,
      isactive: false,
      lastPage: 0,
      currentPage: 0,
      ad1: null,
      ad2: null,
      ad3: null,
      ad4: null,
      ad5: null,
      ad6: null,
      indexCount: 0
    };
  },
  mounted() {
    const _this = this;
    const _href = _this.$route.query.href;
    if (_href) {
      _this.isScroll = _href;
      window.scrollTo(0, _href);
    } else {
      window.scrollTo(0, 0);
    }
    new Swiper(".swiper-container", {
      effect: "fade",
      speed: 1000,
      loop: true,
      preventClicks: true,
      pagination: {
        el: ".swiper-pagination",
        clickable: true
      },
      on: {
        transitionEnd: function() {
          _this.isactive = true;
          _this.shouInLoad(2 * _this.currentPage + 1, true);
        }
      }
    });
    _this.shouInLoad(2 * _this.currentPage + 1, true);
    var bannerSlide = document.getElementsByClassName("bannerSlide");
    if (bannerSlide) {
      _this.autoPlay(true);
    }
  },
  beforeDestroy() {
    clearInterval(auto);
  },
  methods: {
    autoPlay(isAuto) {
      const _this = this;
      var autoFun = function() {
        if (_this.currentPage + 1 >= 3) {
          _this.currentPage = 0;
          _this.handleSlide(0);
        } else {
          _this.handleSlide(_this.currentPage + 1);
        }
      };
      if (isAuto == true) {
        auto = setInterval(autoFun, 3000);
      } else {
        clearInterval(auto);
        auto = setInterval(autoFun, 3000);
      }
    },
    handleLink(_path, _val) {
      this.$router.push({
        path: "/" + _path,
        query: {
          href: _val,
          key: new Date().getTime()
        }
      });
    },
    overShow(_val) {
      this.isShow = _val;
    },
    handleStop(val) {
      this.handleSlide(val);
      this.autoPlay(false);
    },
    handleSlide(idx) {
      const _this = this;
      _this.isactive = false;
      _this.currentPage = idx;
      _this.indexCount = idx;
      if (_this.lastPage == 2) {
        _this.shouOutLoad(5, _this.isactive);
      } else {
        _this.shouOutLoad(2 * _this.lastPage + 1, _this.isactive);
      }
      _this.lastPage = _this.currentPage;
      var autoClick = document.getElementsByClassName(
        "swiper-pagination-bullet"
      )[idx];
      if (autoClick) {
        document.getElementsByClassName("swiper-pagination-bullet")[idx].click();
      } else {
        clearInterval(auto);
      }
    },
    loadTrans(_data, _val, _isTrue) {
      const _this = this;
      setTimeout(function() {
        _this["ad" + _data] = _isTrue;
      }, _val);
    },
    shouInLoad(_data, _isTrue) {
      this.loadTrans(_data, 0, _isTrue);
      this.loadTrans(_data + 1, 0, _isTrue);
    },
    shouOutLoad(_data, _isTrue) {
      this.loadTrans(_data + 1, 0, _isTrue);
      this.loadTrans(_data, 0, _isTrue);
    }
  }
};
</script>
<style lang="scss" scoped>
$color: #40a9ff;
$width: 1200px;
$animateTime: 0.3s;
$offset: 60px;

.none {
  display: none;
}

/deep/ .animated {
  -webkit-animation-duration: 0.3s;
  animation-duration: 0.3s;
  animation-fill-mode: both;
  webkit-animation-play-state: both;
}

.swiper-slide {
  width: 100%;
  /* height: 40vw; */
  /* height: 630px; */
  background-size: cover;

  img {
    height: 100%;
    width: 100%;
  }
}

.text-tontent {
  text-align: center;

  .trans {
    font-size: 14px;
    color: rgba(0, 0, 0, 0.25);
    margin-bottom: 5px;
  }

  .title {
    font-size: 30px;
    font-weight: 500;
    color: rgba(0, 0, 0, 0.85);
    margin-bottom: 60px;
  }

  .desc {
    font-family: PingFangSC-Light, PingFang SC;
    font-size: 20px;
    color: rgba(0, 0, 0, 0.85);
  }

  .desc1 {
    margin-bottom: 20px;
  }
}

.bg-img {
  width: 100%;
  height: 100%;
  transform: scale(1);
  transition: all, $animateTime;
}

.modle {
  transition: all, $animateTime;

  .title {
    transition: all, $animateTime;
    color: rgba(255, 255, 255, 0.85);
  }

  .trans {
    transition: all, $animateTime;
    color: rgba(255, 255, 255, 0.85);
  }

  .go-to {
    transition: all, $animateTime;
  }
}

#content {
  #company-desc {
    padding: 120px 0px;

    .company-content {
      .show-list {
        width: $width;
        padding-top: 120px;
        height: 240px;
        margin: 0 auto;

        .item {
          width: 384px;
          height: 240px;
          margin-left: 24px;
          position: relative;

          .modle {
            position: absolute;
            width: 384px;
            height: 240px;
            background: rgba(0, 0, 0, 0.4);
            left: 0px;
            top: 0px;
            text-align: center;

            .title {
              font-size: 24px;
              margin-top: 102px;
              font-weight: 500;
              color: rgba(255, 255, 255, 0.85);
            }

            .go-to {
              opacity: 0;
              margin-top: 32px;
            }

            &:hover {
              background: rgba(64, 169, 255, 0.85);
            }

            &:hover .title {
              margin-top: 80px;
            }

            &:hover .go-to {
              opacity: 1;
            }
          }

          &:hover .bg-img {
            transform: scale(1.024);
          }
        }

        .first {
          margin-left: 0px;
        }
      }
    }
  }
}

#banner {
  .swiper-pagination {
    opacity: 0;
  }

  .pagination-list {
    position: absolute;
    width: 100%;
    text-align: center;
    bottom: 18px;
    opacity: 1;
    z-index: 999;

    .item {
      height: 4px;
      width: 32px;
      display: inline-block;
      background: #ffffff;
      margin: 5px;
    }

    .active {
      background: $color;
    }
  }

  .swiper-wrapper {
    position: relative;

    .text-content {
      width: 100%;
      position: absolute;
      color: #ffffff;
      text-align: center;
      top: 40%;

      .title {
        display: block;
        height: 46px;
        font-size: 38px;
        color: rgba(255, 255, 255, 0.85);
        line-height: 46px;
      }

      .desc {
        display: block;
        font-size: 14px;
        color: rgba(255, 255, 255, 0.65);
        margin-top: 16px;
      }
    }
  }
}

#company-server {
  padding: 120px 0px;
  background-image: url(~@/assets/image/bg-server.jpg);

  .server-content {
    width: $width + $offset;
    height: 406px;
    margin: 0 auto;

    .title-list {
      width: 284px;

      .title-item {
        margin-left: $offset/2;
        position: relative;
        width: 284px;
        color: rgba(255, 255, 255, 0.5);
        padding-bottom: 109px;
        transition: all, $animateTime;

        .title-after {
          position: absolute;
          opacity: 0;
          width: 5px;
          height: 60px;
          background: rgba(64, 169, 255, 1);
          left: -30px;
          top: 0px;
          transition: all, $animateTime;
        }

        .trans {
          font-size: 14px;
        }

        .title {
          padding-top: 3px;
          font-size: 30px;
          font-weight: 500;
        }

        &:hover {
          margin-left: $offset;
        }

        &:hover .title-after {
          opacity: 1;
        }
      }

      .current {
        margin-left: $offset;
        color: rgba(255, 255, 255, 0.85);

        .title-after {
          opacity: 1;
        }
      }

      .last {
        padding-bottom: 0px;
      }
    }

    .content-list {
      width: 894px;
      height: 406px;
      margin-right: 30px;

      .content-item {
        .item {
          wisth: 282px;
          height: 406px;
          position: relative;
          margin-left: 24px;

          &:hover .bg-img {
            transform: scale(1.024);
          }
        }

        .first {
          margin-left: 0px;
        }

        .modle {
          position: absolute;
          width: 282px;
          height: 406px;
          background: rgba(0, 0, 0, 0.4);
          left: 0px;
          top: 0px;
          color: rgba(255, 255, 255, 1);

          .title {
            font-size: 20px;
            margin: 24px;
            margin-top: 358px;
          }

          .go-to {
            margin-left: 24px;
            opacity: 0;
          }

          &:hover {
            /* background: rgba(64, 169, 255, 0.85); */
          }

          &:hover .title {
            margin-top: 300px;
          }

          &:hover .go-to {
            opacity: 1;
          }
        }
      }

      .finding {
        position: relative;

        &:hover .bg-img {
          transform: scale(1.024);
        }

        .modle {
          position: absolute;
          width: 894px;
          height: 406px;
          background: rgba(0, 0, 0, 0.4);
          left: 0px;
          top: 0px;
          color: rgba(255, 255, 255, 1);

          .title {
            font-size: 20px;
            margin-left: 24px;
            margin-top: 358px;
          }

          .trans {
            font-size: 14px;
            margin-left: 24px;
            color: rgba(255, 255, 255, 0.65);
          }

          .go-to {
            margin-left: 24px;
            opacity: 0;
          }

          &:hover {
            /* background: rgba(64, 169, 255, 0.85); */
          }

          &:hover .title {
            margin-top: 300px;
            margin-bottom: 10px;
          }

          &:hover .go-to {
            opacity: 1;
          }
        }
      }
    }
  }
}
</style>
